export default __webpack_public_path__ + "static/media/searchApp.0f3228b6.png";